import type { QueryHookOptions, TypedDocumentNode } from '@apollo/client';
import { gql, useQuery } from '@apollo/client';
import type { Query, QueryLeadAnalystArgs } from '@/types/GraphqlSchema';

type LeadAnalystQueryData = Pick<Query, 'leadAnalyst'>;
type LeadAnalystQueryVariables = QueryLeadAnalystArgs;

const LEAD_ANALYST_QUERY: TypedDocumentNode<LeadAnalystQueryData, LeadAnalystQueryVariables> = gql`
  query leadAnalystForValuationsV2($countryIsoCode: String!) {
    leadAnalyst(countryIsoCode: $countryIsoCode) {
      name
      email
    }
  }
`;

export const useLeadAnalyst = (
  countryIsoCode: string | null,
  options?: QueryHookOptions<LeadAnalystQueryData, LeadAnalystQueryVariables>,
) => {
  const shouldSkip = !countryIsoCode;

  const queryOptions: QueryHookOptions<LeadAnalystQueryData, LeadAnalystQueryVariables> = {
    fetchPolicy: 'cache-and-network',
    skip: shouldSkip,
    ...(shouldSkip ? {} : { variables: { countryIsoCode: countryIsoCode } }),
    ...(options ?? {}),
  };

  const { data, loading, error } = useQuery<LeadAnalystQueryData, LeadAnalystQueryVariables>(
    LEAD_ANALYST_QUERY,
    queryOptions,
  );

  return {
    data,
    loading,
    error,
    leadAnalyst: data?.leadAnalyst ?? null,
  } as const;
};

export type UseLeadAnalystReturn = ReturnType<typeof useLeadAnalyst>;
